import { render, staticRenderFns } from "./CameraPageShootButton.vue?vue&type=template&id=f3f4a8da&scoped=true&"
import script from "./CameraPageShootButton.vue?vue&type=script&lang=ts&"
export * from "./CameraPageShootButton.vue?vue&type=script&lang=ts&"
import style0 from "./CameraPageShootButton.vue?vue&type=style&index=0&id=f3f4a8da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3f4a8da",
  null
  
)

export default component.exports